import React from 'react';
import { createPortal } from 'react-dom';
import { X, Keyboard } from 'lucide-react';
import { SHORTCUTS } from './mailUtils';

export const ShortcutsHelp = ({ onClose }) => createPortal(
  <div className="fixed inset-0 z-[9000] bg-slate-900/40 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose} data-testid="mail-shortcuts-help">
    <div className="w-full max-w-lg bg-white rounded-2xl shadow-2xl border border-slate-200 p-5" onClick={e => e.stopPropagation()}>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-black text-slate-900 uppercase tracking-wider flex items-center gap-2"><Keyboard className="w-4 h-4 text-sky-700" />Keyboard shortcuts</h3>
        <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-slate-100 text-slate-500" data-testid="mail-shortcuts-close"><X className="w-4 h-4" /></button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1.5">
        {SHORTCUTS.map(([k, d]) => (
          <div key={k} className="flex items-center justify-between gap-3 text-xs py-1 border-b border-slate-100">
            <span className="text-slate-600">{d}</span>
            <kbd className="font-mono text-[11px] font-bold text-slate-900 bg-slate-100 border border-slate-200 rounded px-1.5 py-0.5 whitespace-nowrap">{k}</kbd>
          </div>
        ))}
      </div>
    </div>
  </div>, document.body);
